import React from "react";
import PropTypes from "prop-types";
import { Map } from "immutable";
import classNames from "classnames";

import { getPartNumberColorClassNameByTierType } from "MODULES/shared/helpers";
import { PART_NUMBER, TIER_TYPE } from "MODULES/parts/constants";

function PartLabel({ part }) {
  const tierType = part.get(TIER_TYPE);

  const classes = classNames(
    "header-content",
    getPartNumberColorClassNameByTierType(tierType)
  );

  return <span className={classes}>{part.get(PART_NUMBER)}</span>;
}

PartLabel.propTypes = {
  part: PropTypes.instanceOf(Map)
};

export default PartLabel;



// WEBPACK FOOTER //
// ./app/modules/inventories/components/Detail/Header/PartLabel.jsx